<ng-container *ngIf="(homePageContent$ | async) as content">

  <h2 mat-dialog-title>Edit Home Page Header</h2>
  <div class="msg-wrapper">
    <messages></messages>
  </div>

  <loading></loading>

  <mat-dialog-content>

    <mat-tab-group>

      <mat-tab label="Brand Images">

        <div class="tab-body">

          <div class="image-label">
            Choose background banner (mandatory):
          </div>

          <div class="field-hint">The recommended dimensions are around 2048x1034 px. Place the main elements of the
            design like a title or logo in the center of the image, as the sides will be cropped on mobile.</div>

          <file-upload class="logo-image" [src]="content.bannerImageUrl"  [processing]="false" [allowDelete]="true"
            accept="image/*" (fileSelected)="onBannerSelected($event, content)" width="100%" height="153px"
            (fileDeleted)="onImageDeleted('banner', content)">

          </file-upload>

          <file-upload-progress class="banner-upload" [upload$]="bannerPercentageUpload$" width="450px"
            (cancel)="onBannerCancelUpload()">

          </file-upload-progress>


          <div class="image-label">
            Choose logo (optional):
          </div>

          <div class="field-hint">You don't have to upload a separate logo, you can also add it directly in the
            background banner.</div>

          <file-upload class="banner-image" [src]="content.logoImageUrl"  [componentShape]="'square'" [processing]="false" [allowDelete]="true"
            accept="image/*" (fileSelected)="onLogoSelected($event, content)" height="150px" width="150px"
            (fileDeleted)="onImageDeleted('logo', content)">

          </file-upload>

          <file-upload-progress class="banner-upload" [upload$]="logoPercentageUpload$" width="450px"
            (cancel)="onLogoCancelUpload()">

          </file-upload-progress>



        </div>

      </mat-tab>

      <mat-tab label="Website Title">

        <div class="tab-body" [formGroup]="form">

          <mat-form-field class="edit-title" appearance="outline">

            <input matInput placeholder="Edit home page title" formControlName="title">

          </mat-form-field>

          <div class="title-options">

            <color-field [color]="titleColor" label="Title Color" (colorEdited)="onTitleColorChanged($event)">

            </color-field>

            <div class="font-size-container">

              <span>Font size:</span>

              <mat-form-field appearance="outline" class="title-font-size">

                <input type="number" matInput placeholder="font size" formControlName="titleFontSize">

              </mat-form-field>

              <div class="pixels">px</div>

            </div>

          </div>

          <div class="view-courses-button-options">

          </div>

        </div>

      </mat-tab>

    </mat-tab-group>

  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">

    <button mat-raised-button color="primary" (click)="save(content)" [disabled]="!form.valid">Save</button>

    <button mat-raised-button (click)="close()">Close</button>

  </mat-dialog-actions>

</ng-container>
